<template>
  <div id="home" :class="{ 'menu-open': isMenuOpen }">
    <div class="bg-noise" aria-hidden="true"></div>
    <div class="bg-glow bg-glow-left" aria-hidden="true"></div>
    <div class="bg-glow bg-glow-right" aria-hidden="true"></div>

    <header class="site-header" :class="{ 'is-sticky': isSticky }">
      <div class="container nav-wrap">
        <a class="brand" href="#top" aria-label="回到顶部">
          <img class="brand-logo" :src="logoSrc" alt="酷外智联 Logo" />
          <span class="brand-text">
            <strong>酷外智联</strong>
            <small>Shenzhen Coolwal Intelligent</small>
          </span>
        </a>

        <button
          class="menu-toggle"
          type="button"
          :aria-expanded="String(isMenuOpen)"
          aria-controls="primary-nav"
          aria-label="切换导航"
          @click="toggleMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav id="primary-nav" class="nav-links" :class="{ 'is-open': isMenuOpen }" aria-label="主导航">
          <a href="#about" v-smooth-scroll @click="closeMenu">公司定位</a>
          <a href="#products" v-smooth-scroll @click="closeMenu">产品能力</a>
          <a href="#rd" v-smooth-scroll @click="closeMenu">研发体系</a>
          <a href="#base" v-smooth-scroll @click="closeMenu">生产基地</a>
          <a href="#contact" v-smooth-scroll @click="closeMenu">联系合作</a>
          <a class="cta-link" href="#contact" v-smooth-scroll @click="closeMenu">立即咨询</a>
        </nav>
      </div>
    </header>

    <main id="top">
      <section class="hero section">
        <div class="container hero-grid">
          <div class="hero-copy">
            <p class="kicker">两轮车载智能硬件研发与交付</p>
            <h1>把创意做成可量产的智能配件产品</h1>
            <p class="hero-desc">
              深圳酷外智联专注智能蓝牙音响、仪表、氛围灯及车灯等车载配件，
              打通硬件研发、软件联动、App/小程序中控与样品打样，帮助客户更快完成产品化。
            </p>
            <div class="hero-actions">
              <a href="#contact" class="btn btn-primary" v-smooth-scroll>预约方案沟通</a>
              <a href="#products" class="btn btn-secondary" v-smooth-scroll>查看能力矩阵</a>
            </div>
            <ul class="hero-points">
              <li>软硬件一体研发</li>
              <li>支持定制化开发</li>
              <li>东莞基地量产支撑</li>
            </ul>
          </div>

          <aside class="hero-panel" aria-label="能力概览">
            <div class="panel-head">
              <h2>能力速览</h2>
              <span>Capability Snapshot</span>
            </div>
            <div class="panel-stats">
              <article>
                <strong>5+</strong>
                <p>跨职能团队协同</p>
              </article>
              <article>
                <strong>4</strong>
                <p>核心产品方向</p>
              </article>
              <article>
                <strong>2</strong>
                <p>深圳 + 东莞双基地</p>
              </article>
              <article>
                <strong>1</strong>
                <p>完整打样到量产链路</p>
              </article>
            </div>
            <div class="panel-tags">
              <span>Bluetooth Audio</span>
              <span>Smart Dashboard</span>
              <span>Ambient Light</span>
              <span>Mini Program + App</span>
            </div>
          </aside>
        </div>
      </section>

      <section id="about" class="section trust">
        <div class="container">
          <div class="section-head">
            <p class="kicker">公司定位</p>
            <h2>研发驱动型企业，面向两轮车智能配件持续创新</h2>
            <p>
              公司以产品研发为核心，围绕软件团队、硬件团队、销售市场团队、电商团队协同运作，
              由深圳团队负责研发与样品打样，联动东莞生产基地承接规模交付。
            </p>
          </div>

          <div class="trust-grid">
            <article class="trust-card">
              <h3>软件团队</h3>
              <p>负责小程序、App 与智能中控功能联动，提升用户交互与设备可控性。</p>
            </article>
            <article class="trust-card">
              <h3>硬件团队</h3>
              <p>覆盖电路、结构、声学、灯光设计与调试，保证性能与稳定性平衡。</p>
            </article>
            <article class="trust-card">
              <h3>销售市场团队</h3>
              <p>洞察终端场景和客户需求，推动研发方向与功能优先级更贴近市场。</p>
            </article>
            <article class="trust-card">
              <h3>电商团队</h3>
              <p>基于线上运营反馈优化产品表达，帮助客户提升转化与复购表现。</p>
            </article>
          </div>
        </div>
      </section>

      <section id="products" class="section products">
        <div class="container">
          <div class="section-head">
            <p class="kicker">产品能力</p>
            <h2>车载智能配件产品矩阵</h2>
          </div>
          <div class="product-grid">
            <article class="product-card">
              <h3>智能蓝牙音响</h3>
              <p>优化骑行场景下的音质、抗干扰和连接稳定，支持多设备联动控制。</p>
            </article>
            <article class="product-card">
              <h3>智能仪表</h3>
              <p>集成里程、电量、状态告警等信息，支持品牌化 UI 与交互定制。</p>
            </article>
            <article class="product-card">
              <h3>氛围灯系统</h3>
              <p>提供多模式灯效策略，兼顾个性表达与行驶场景下的实用反馈。</p>
            </article>
            <article class="product-card">
              <h3>车灯配件</h3>
              <p>面向安全与法规需求，支持照明方案优化与结构、电气适配。</p>
            </article>
            <article class="product-card">
              <h3>智能中控方案</h3>
              <p>通过小程序与 App 构建设备管理中台，实现配置、升级与诊断能力。</p>
            </article>
            <article class="product-card">
              <h3>定制化组合开发</h3>
              <p>按客户定位组合硬件模块与软件功能，缩短从概念到样机的时间。</p>
            </article>
          </div>
        </div>
      </section>

      <section id="rd" class="section rd">
        <div class="container rd-grid">
          <div class="rd-left">
            <div class="section-head">
              <p class="kicker">研发体系</p>
              <h2>从需求到样品，流程透明、协同高效</h2>
            </div>
            <ol class="timeline">
              <li>
                <span>01</span>
                <div>
                  <h3>需求定义</h3>
                  <p>结合目标用户、车型与渠道，明确功能优先级与交付边界。</p>
                </div>
              </li>
              <li>
                <span>02</span>
                <div>
                  <h3>联合设计</h3>
                  <p>软硬件同步设计，确定通信协议、供电方案、结构与交互体验。</p>
                </div>
              </li>
              <li>
                <span>03</span>
                <div>
                  <h3>样品打样</h3>
                  <p>深圳团队快速迭代样机，完成可测试版本并验证核心参数。</p>
                </div>
              </li>
              <li>
                <span>04</span>
                <div>
                  <h3>试产交付</h3>
                  <p>东莞基地导入工艺与测试流程，确保后续量产一致性与稳定性。</p>
                </div>
              </li>
            </ol>
          </div>

          <aside class="rd-right">
            <h3>可定制模块</h3>
            <ul>
              <li>外观结构设计与打样</li>
              <li>蓝牙连接与协议适配</li>
              <li>音频系统调校与功放方案</li>
              <li>灯效策略与场景联动</li>
              <li>App / 小程序控制面板</li>
              <li>量产测试流程定义</li>
            </ul>
            <a href="#contact" class="btn btn-primary block" v-smooth-scroll>获取定制清单</a>
          </aside>
        </div>
      </section>

      <section id="base" class="section base">
        <div class="container base-grid">
          <article class="base-card">
            <p class="kicker">深圳</p>
            <h3>研发与样品打样中心</h3>
            <p>快速完成概念验证、软硬件联调、样机优化，是产品创新的核心发动机。</p>
          </article>
          <article class="base-card">
            <p class="kicker">东莞</p>
            <h3>生产基地</h3>
            <p>承接试产与规模化交付，保障产品从样品阶段平滑进入量产阶段。</p>
          </article>
        </div>
      </section>
    </main>

    <footer id="contact" class="site-footer section">
      <div class="container footer-grid">
        <div>
          <p class="kicker">联系合作</p>
          <h2>欢迎沟通车载智能配件定制项目</h2>
          <p class="footer-desc">深圳酷外智联科技有限公司（研发与样品打样中心）</p>
        </div>
        <div class="contact-list">
          <p><strong>业务邮箱：</strong><a href="mailto:zhangqiang@coolwal.com">zhangqiang@coolwal.com</a></p>
          <p><strong>联系电话：</strong><a href="tel:0755015500052">0755-015500052</a></p>
          <p><strong>公司地址：</strong>深圳市光明区公明街道上村社区公常公路 90 号石观工业园</p>
          <p class="icp-row">
            <img class="police-icon" :src="policeIconSrc" alt="公安备案图标" />
            <span><strong>备案信息：</strong><a href="https://beian.miit.gov.cn" target="_blank" rel="noopener">粤 ICP 备 2024241766 号-4</a></span>
          </p>
        </div>
      </div>
      <p class="copyright">© 2026 深圳酷外智联科技有限公司</p>
      <a class="to-top" href="#top" aria-label="返回顶部" v-smooth-scroll>↑</a>
    </footer>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  data() {
    return {
      isSticky: false,
      isMenuOpen: false,
      logoSrc: require("../assets/logo.png"),
      policeIconSrc: require("../assets/images/police_icon.d0289dc0.png"),
    };
  },
  methods: {
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      this.isSticky = scrollTop > 44;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="less" scoped>
#home {
  --surface: #ffffff;
  --text: #020617;
  --muted: #475569;
  --line: #d9e2ef;
  --primary: #0f172a;
  --accent: #0369a1;
  --accent-soft: rgba(3, 105, 161, 0.12);
  --section-bg: #f4f8fd;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  color: var(--text);
  background: linear-gradient(180deg, #f8fbff 0%, #eff5fb 100%);
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

* {
  box-sizing: border-box;
}

.bg-noise {
  position: fixed;
  inset: 0;
  pointer-events: none;
  opacity: 0.2;
  background-image:
    radial-gradient(circle at 25% 30%, rgba(2, 6, 23, 0.05) 1px, transparent 1px),
    radial-gradient(circle at 75% 70%, rgba(3, 105, 161, 0.05) 1px, transparent 1px);
  background-size: 24px 24px, 26px 26px;
  z-index: 0;
}

.bg-glow {
  position: absolute;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.32;
  pointer-events: none;
  z-index: 0;
}

.bg-glow-left {
  background: #60a5fa;
  top: -180px;
  left: -120px;
}

.bg-glow-right {
  background: #0ea5e9;
  top: 140px;
  right: -180px;
}

.container {
  width: calc(100% - 40px);
  max-width: 1160px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.section {
  padding: 84px 0;
}

.kicker {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: var(--accent);
  text-transform: uppercase;
  margin-bottom: 14px;
}

.section-head {
  max-width: 820px;
  margin-bottom: 30px;
}

.section-head h2 {
  font-size: clamp(28px, 4.3vw, 42px);
  line-height: 1.2;
  margin-bottom: 12px;
}

.section-head p {
  color: var(--muted);
  line-height: 1.8;
  font-size: 16px;
}

.site-header {
  position: fixed;
  top: 14px;
  left: 0;
  right: 0;
  z-index: 40;
}

.nav-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  background: rgba(255, 255, 255, 0.86);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 10px 14px;
  backdrop-filter: blur(8px);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.site-header.is-sticky .nav-wrap {
  border-color: rgba(3, 105, 161, 0.35);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  color: inherit;
}

.brand-logo {
  width: 42px;
  height: 42px;
  object-fit: contain;
  border-radius: 10px;
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-text strong {
  font-size: 16px;
  line-height: 1.1;
}

.brand-text small {
  color: var(--muted);
  font-size: 11px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 3px;
}

.nav-links a {
  font-size: 14px;
  font-weight: 500;
  color: var(--primary);
  border-radius: 9px;
  padding: 10px 12px;
  transition: color 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
}

.nav-links a:hover,
.nav-links a:focus-visible {
  color: var(--accent);
  background: var(--accent-soft);
  outline: none;
}

.nav-links .cta-link {
  margin-left: 8px;
  background: var(--primary);
  color: #ffffff;
}

.nav-links .cta-link:hover,
.nav-links .cta-link:focus-visible {
  background: #1e293b;
  color: #ffffff;
}

.menu-toggle {
  display: none;
  width: 42px;
  height: 42px;
  border: 1px solid var(--line);
  background: #ffffff;
  border-radius: 10px;
  padding: 0;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 18px;
  height: 2px;
  background: var(--primary);
  margin: 4px auto;
}

.hero {
  padding-top: 140px;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.hero-grid {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 18px;
  align-items: stretch;
}

.hero-copy h1 {
  font-size: clamp(34px, 6vw, 58px);
  line-height: 1.1;
  margin-bottom: 16px;
}

.hero-desc {
  color: var(--muted);
  font-size: 18px;
  line-height: 1.8;
  max-width: 700px;
}

.hero-actions {
  margin-top: 28px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  padding: 12px 18px;
  font-weight: 600;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
}

.btn:hover,
.btn:focus-visible {
  transform: translateY(-1px);
  outline: none;
}

.btn-primary {
  color: #ffffff;
  background: linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.2);
}

.btn-primary:hover,
.btn-primary:focus-visible {
  background: linear-gradient(135deg, #1e293b 0%, #1e40af 100%);
}

.btn-secondary {
  border: 1px solid var(--line);
  color: var(--primary);
  background: #ffffff;
}

.btn-secondary:hover,
.btn-secondary:focus-visible {
  border-color: #93c5fd;
  box-shadow: 0 8px 20px rgba(3, 105, 161, 0.16);
}

.hero-points {
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.hero-points li {
  border: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.88);
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 13px;
  color: #0f172a;
}

.hero-panel {
  background: rgba(15, 23, 42, 0.94);
  color: #dbeafe;
  border-radius: 18px;
  border: 1px solid rgba(147, 197, 253, 0.24);
  padding: 18px;
  box-shadow: 0 20px 36px rgba(15, 23, 42, 0.25);
}

.panel-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 14px;
}

.panel-head h2 {
  font-size: 22px;
}

.panel-head span {
  color: #93c5fd;
  font-size: 12px;
}

.panel-stats {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.panel-stats article {
  background: rgba(30, 41, 59, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.3);
  border-radius: 12px;
  padding: 12px;
}

.panel-stats strong {
  display: block;
  font-size: 28px;
  color: #f8fafc;
  margin-bottom: 6px;
}

.panel-stats p {
  font-size: 13px;
  line-height: 1.5;
  color: #cbd5e1;
}

.panel-tags {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.panel-tags span {
  background: rgba(14, 116, 144, 0.24);
  color: #bfdbfe;
  border: 1px solid rgba(125, 211, 252, 0.38);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 12px;
}

.trust {
  background: var(--section-bg);
}

.trust-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.trust-card,
.product-card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 20px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.trust-card:hover,
.product-card:hover {
  transform: translateY(-2px);
  border-color: rgba(3, 105, 161, 0.36);
  box-shadow: 0 14px 26px rgba(15, 23, 42, 0.09);
}

.trust-card h3,
.product-card h3 {
  font-size: 20px;
  margin-bottom: 8px;
}

.trust-card p,
.product-card p {
  color: var(--muted);
  line-height: 1.75;
}

.products {
  background: linear-gradient(180deg, #f6faff 0%, #eef6ff 100%);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.rd-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 14px;
}

.timeline {
  display: grid;
  gap: 10px;
}

.timeline li {
  background: #ffffff;
  border: 1px solid var(--line);
  border-radius: 13px;
  padding: 16px;
  display: grid;
  grid-template-columns: 52px 1fr;
  gap: 12px;
}

.timeline span {
  width: 52px;
  height: 52px;
  border-radius: 11px;
  display: grid;
  place-items: center;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #0f172a 0%, #0284c7 100%);
}

.timeline h3 {
  font-size: 19px;
  margin-bottom: 6px;
}

.timeline p {
  color: var(--muted);
  line-height: 1.7;
}

.rd-right {
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 20px;
  background: #ffffff;
}

.rd-right h3 {
  font-size: 24px;
  margin-bottom: 14px;
}

.rd-right ul {
  display: grid;
  gap: 8px;
  margin-bottom: 16px;
}

.rd-right li {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 9px 11px;
  color: #334155;
  background: #f8fafc;
}

.btn.block {
  width: 100%;
}

.base {
  background: var(--section-bg);
}

.base-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.base-card {
  background: linear-gradient(145deg, #ffffff 0%, #eff6ff 100%);
  border: 1px solid var(--line);
  border-radius: 16px;
  padding: 22px;
}

.base-card h3 {
  font-size: 26px;
  margin-bottom: 10px;
}

.base-card p {
  color: #334155;
  line-height: 1.8;
}

.site-footer {
  padding-top: 74px;
  padding-bottom: 84px;
  background: #0b1323;
  color: #e2e8f0;
  position: relative;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.site-footer .kicker {
  color: #7dd3fc;
}

.site-footer h2 {
  font-size: clamp(28px, 4vw, 38px);
  line-height: 1.2;
  margin-bottom: 12px;
}

.footer-desc {
  color: #cbd5e1;
}

.contact-list p {
  margin-bottom: 8px;
  line-height: 1.8;
  color: #cbd5e1;
}

.contact-list a {
  color: #7dd3fc;
  text-decoration: underline;
}

.icp-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.police-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.copyright {
  text-align: center;
  margin-top: 22px;
  color: #94a3b8;
  font-size: 13px;
}

.to-top {
  position: fixed;
  right: 20px;
  bottom: 22px;
  z-index: 120;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 18px;
  color: #ffffff;
  background: linear-gradient(135deg, #1d4ed8 0%, #0369a1 100%);
  box-shadow: 0 10px 24px rgba(3, 105, 161, 0.3);
  cursor: pointer;
  pointer-events: auto;
}

@supports (bottom: env(safe-area-inset-bottom)) {
  .to-top {
    bottom: calc(env(safe-area-inset-bottom) + 18px);
  }
}

@media (max-width: 1080px) {
  .hero-grid,
  .rd-grid {
    grid-template-columns: 1fr;
  }

  .trust-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .product-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .footer-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 860px) {
  .menu-toggle {
    display: inline-block;
  }

  .nav-links {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 100%;
    max-width: 280px;
    display: none;
    flex-direction: column;
    align-items: stretch;
    background: #ffffff;
    border: 1px solid var(--line);
    border-radius: 14px;
    padding: 10px;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
  }

  .nav-links.is-open {
    display: flex;
  }

  .nav-links .cta-link {
    margin-left: 0;
  }

  #home.menu-open {
    overflow: hidden;
  }
}

@media (max-width: 680px) {
  .container {
    width: calc(100% - 28px);
  }

  .section {
    padding: 68px 0;
  }

  .trust-grid,
  .product-grid,
  .base-grid {
    grid-template-columns: 1fr;
  }

  .panel-stats {
    grid-template-columns: 1fr;
  }

  .timeline li {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation: none !important;
    transition: none !important;
    scroll-behavior: auto !important;
  }
}
</style>
